import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateContentSharingPermissionMutationVariables = Types.Exact<{
  input: Types.UpdateContentSharingPermissionInput;
}>;


export type UpdateContentSharingPermissionMutation = { __typename?: 'Mutation', updateContentSharingPermission?: { __typename?: 'ContentSharingPermissionMutationResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null } | null };


export const UpdateContentSharingPermissionDocument = gql`
    mutation updateContentSharingPermission($input: UpdateContentSharingPermissionInput!) {
  updateContentSharingPermission(input: $input) {
    success
    error {
      code
      message
    }
  }
}
    `;
export type UpdateContentSharingPermissionMutationFn = Apollo.MutationFunction<UpdateContentSharingPermissionMutation, UpdateContentSharingPermissionMutationVariables>;

/**
 * __useUpdateContentSharingPermissionMutation__
 *
 * To run a mutation, you first call `useUpdateContentSharingPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentSharingPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentSharingPermissionMutation, { data, loading, error }] = useUpdateContentSharingPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentSharingPermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentSharingPermissionMutation, UpdateContentSharingPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentSharingPermissionMutation, UpdateContentSharingPermissionMutationVariables>(UpdateContentSharingPermissionDocument, options);
      }
export type UpdateContentSharingPermissionMutationHookResult = ReturnType<typeof useUpdateContentSharingPermissionMutation>;
export type UpdateContentSharingPermissionMutationResult = Apollo.MutationResult<UpdateContentSharingPermissionMutation>;
export type UpdateContentSharingPermissionMutationOptions = Apollo.BaseMutationOptions<UpdateContentSharingPermissionMutation, UpdateContentSharingPermissionMutationVariables>;